import { Component, OnInit } from '@angular/core';
import { PermitAll } from '@csx/security';

/**
 * @export
 * @class OutlyingPointComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-outlying-point',
  templateUrl: './outlying-point.component.html',
  styleUrls: ['./outlying-point.component.scss']
})
@PermitAll()
export class OutlyingPointComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
